import type { ApiResponseForJsend } from 'Services/motorway/apiClient.types';

export async function getDataFromResponse<T>(query: Promise<ApiResponseForJsend<T>>): Promise<T> {
	const response = await query;
	if (response.status === 'success') {
		return response.data;
	}
	throw new Error(`Received not successful status. Status:${response?.status ?? 'No status'}`);
}
